import { Col, Row, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import { Links } from '../../helpers/Links';
import { BacLuongResponse, ChiTietHopDongResponse, HopDong, PhuCapResponse } from "../../models/hopdong/HopDong";
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import { layCTHopDong, layDanhSachPhuCapTheoHDvaQDBL, layDsHopDongTheoIdNhanVien } from "../../services/hopdong";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import NhanVienHopDongBox from '../nhanvien/NhanVienHopDongBox';
import DanhSachHopDongBox from './DanhSachHopDongBox';
import QuyetDinhBatLuongBox from './QuyetDinhBatLuongBox';

const XemHopDongCaNhan = () => {
    let navigate = useNavigate();    
    const user = useSelector((state: any) => state.auth.currentUser);
    const [defaultSelectBacLuong, setDefaultSelectBacLuong] = useState<BacLuongResponse | undefined>(undefined);
    const [reloadPage, setReloadPage] = useState(false);
    const [reloadDsHopDong, setReloadDsHopDong] = useState(false);
    const [idHopDong, setIdHopDong] = useState<number>(0);
    const [idQDBL, setIdQDBL] = useState<number>(0);
    const [dsHopDong, setDsHopDong] = useState<Array<HopDong>>([]);
    const [modelProps, setModelProps] = useState<ChiTietHopDongResponse | null>(null);
    const [hopDongInfo, setHopDongInfo] = useState<ChiTietHopDongResponse>(new ChiTietHopDongResponse);
    const [nhanVien, setNhanVien] = useState<NhanVienResponse>(new NhanVienResponse);
    const dispatch = useDispatch();

    const layChiTiet = async (id: number) => {
        if (id > 0) {
            var rs = await layCTHopDong(id);
            setHopDongInfo(rs);
            if (rs.bacLuong.length > 0) {
                let selectDefault = rs.bacLuong[0];
                setIdQDBL(selectDefault.idQuyetDinhBacLuong);
                setDefaultSelectBacLuong(selectDefault)
            } else {
                setIdQDBL(0);
                setDefaultSelectBacLuong(undefined);
            }
        }
    };

    const layDsHopDong = async (idNV: number) => {
        try {
            dispatch(showLoadingScreen());
            if (idNV > 0) {
                var rs = await layDsHopDongTheoIdNhanVien(idNV);
                if (rs.dsHopDong.length > 0) {
                    if (modelProps == null) {
                        let selectDefault = rs.dsHopDong.find(x => x.trangThai === 1) || rs.dsHopDong[0];
                        setIdHopDong(selectDefault.id);
                        setReloadPage(true);
                    }
                } else {
                    setIdHopDong(0);
                    setHopDongInfo(new ChiTietHopDongResponse);
                }
                setDsHopDong(rs.dsHopDong);
                setNhanVien(rs.nhanVienInfo);
            }
            dispatch(hideLoadingScreen());
        }
        catch (error: any) {
            toast.error('Có lỗi xảy ra, hãy thử lại sau!')
            navigate(Links.HopDong.DanhSach);
            dispatch(hideLoadingScreen());
        }
    };
    useEffect(() => {
        dispatch(showLoadingScreen());
        layDsHopDong(user.idNhanVien);
        dispatch(hideLoadingScreen());
    }, [])

    useEffect(() => {
        if (reloadPage) {
            layChiTiet(idHopDong);
            setReloadPage(false);
        }
    }, [reloadPage])

    useEffect(() => {
        if (reloadDsHopDong) {
            dispatch(showLoadingScreen());
            if (nhanVien != null) {
                layDsHopDong(nhanVien?.id);
                if (modelProps != null) {
                    setIdHopDong(modelProps?.id)
                    setReloadPage(true);
                }
            }
            dispatch(hideLoadingScreen());
            setReloadDsHopDong(false);
        }
        setReloadDsHopDong(false);
    }, [reloadDsHopDong])

    return (
        <section >
            <ContentHeader title="Hợp đồng/Quyết định bổ nhiệm" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: 'Thông tin cá nhân',
                                children: <NhanVienHopDongBox nhanVien={nhanVien} />
                            },
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Danh sách hợp đồng/quyết định bổ nhiệm',
                                    children:
                                        <Col span="24" className="card qlns-search-box">
                                            <DanhSachHopDongBox defaultSelect={(dsHopDong || []).length > 0 ? modelProps != null ? dsHopDong?.find(x => x.id == modelProps.id) : dsHopDong[0] : undefined}
                                                listData={dsHopDong} select={true}
                                                hopDongInfo={hopDongInfo}
                                                onSubmit={() => { setReloadPage(true) }}
                                                idNhanVien={nhanVien?.id}
                                                onRowSelected={(e: HopDong) => {
                                                setIdHopDong(e?.id);
                                                setReloadPage(true);
                                            }} />
                                        </Col>
                                },
                            ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            {idHopDong > 0 &&
                    <Row>
                        <Col span="24">
                            <QuyetDinhBatLuongBox idHopDong={idHopDong} listData={hopDongInfo?.bacLuong} onSubmit={() => { setReloadPage(true) }}
                                select={true}
                                defaultSelect={defaultSelectBacLuong}
                                onRowSelected={(e: BacLuongResponse) => {
                                    setIdQDBL(e?.idQuyetDinhBacLuong);
                                    setDefaultSelectBacLuong(e);
                                }} />
                        </Col>
                    </Row>
            }
        </section >
    )
}

export default XemHopDongCaNhan